<template lang="pug">
    d2-container
        el-form(:inline='true', :model='dataForm'  size='mini' label-width="75px" label-position='right' :modal-append-to-body='false'  label-suffix=':' )
            el-row()
              el-col(:md='6' :sm="12")  
                el-form-item(label="培训名称" )
                      el-input.inputWidth(v-model='dataForm.pxName' clearable )
              el-col(:md='6' :sm="12")  
                el-form-item(label="主办方" )
                  el-select.inputWidth(v-model="dataForm.orgId",placeholder="请选择" filterable clearable )
                      el-option(v-for="(item,index) in sysOrgList",:key="index",:label="item.name",:value="item.orgId" )     
              el-col(:md='6' :sm="12")  
                el-form-item(label="状态" )
                    el-select.matchStatus.inputWidth(v-model='dataForm.state' clearable)
                      el-option(v-for='(e, i) in pxState' :key='i' :label="e.label" :value="e.value")           
        el-row(style="padding-bottom:15px;" :span="24")
            el-col(:md='23' :sm="5")
                el-button(@click='addOrUpdateHandle(null,1)'   type='primary' v-if="isAuth('px:group:add')" ) 新建培训
            el-col( :md='1' :sm="14" style='float:right;')
                el-button(@click='queryList()',type='primary',icon='el-icon-search',style='float:right;') 查 询
        el-table(:data="tableData" style="width: 100%" v-loading='dataListLoading' border @selection-change='selectionChangeHandle')
            el-table-column(prop='trainCode',header-align='center',align='center',label='培训ID' )
            el-table-column(prop='name',header-align='center',align='center',label='培训名称')
            el-table-column(prop='orgName',header-align='center',align='center',label='主办方')
            el-table-column(prop='state',header-align='center',align='center',label='状态')
                template(slot-scope="scope")
                    font(v-if='scope.row.state === 1') 
                      span.danger()
                      span() &nbsp; 未审核 
                    font(v-if='scope.row.state === 2')
                      span.warning()
                      span() &nbsp; 已拒绝 
                    font(v-if='scope.row.state === 3')
                      span.success()
                      span() &nbsp; 已发布
                    font(v-if='scope.row.state === 4')
                      span.warning()
                      span() &nbsp; 报名中
                    font(v-if='scope.row.state === 5')
                      span.warning()
                      span() &nbsp; 报名结束
                    font(v-if='scope.row.state === 6' )
                      span.warning()
                      span() &nbsp; 已开训
                    font(v-if='scope.row.state === 7')
                      span.warning()
                      span() &nbsp; 已结束
                    font(v-if='scope.row.state === 8')
                      span.warning()
                      span() &nbsp; 已取消
            el-table-column(prop='',header-align='center',align='center',label='操作' width='100')
                    template(slot-scope="scope")
                      el-menu.menuPonit(   @open="handleOpen" @close="handleClose" :collapse="isCollapse" )
                        el-submenu(index="1")
                            template(slot="title") 
                                i(class="el-icon-more" style='color:#02B90D;')
                            el-menu-item-group()
                                el-menu-item(index="1-1" @click="queryHandle(scope.row.id,1)" v-if="isAuth('px:group:detail')" ) 查看详情
                                el-menu-item(index="1-2" @click="addOrUpdateHandle(scope.row.id,2)"  type="text" v-if="(scope.row.state != 7 && scope.row.state != 8) && isAuth('px:group:update')" ) 修改培训
                                el-menu-item(index="1-3" @click='queryHandle(scope.row.id,2)' type='primary' v-if="scope.row.state == 1 && isAuth('px:group:apply')" ) 审核发布
                                el-menu-item(index="1-4" @click='enrollClick(scope.row,1)' type='primary' v-if="[3,4,5,6].indexOf(scope.row.state)>-1&&isAuth('px:group:userlist')" ) 报名管理
                                el-menu-item(index="1-5" @click='overBm(scope.row.id,1)' type='primary' v-if="[3,4,5,6].indexOf(scope.row.state)>-1 && isAuth('px:group:over')" ) 结束培训
        el-pagination(@size-change='sizeChangeHandle', @current-change='currentChangeHandle', :current-page='pageIndex', :page-sizes='[10, 20, 50, 100]', :page-size='pageSize', :total='totalPage', layout='total, sizes, prev, pager, next, jumper')
        //添加和修改
        addOrUpdate(v-if='addOrUpdateVisible', ref="addOrUpdate",@refreshDataList='queryList')
        //查看和审核
        queryView(v-if='queryViewVisible', ref="queryView",@refreshDataList='queryList')
        //报名管理
        elEnrollInfo(v-if='elEnrollInfoVisible',ref="elEnrollInfo",@refreshDataList='queryList')
        //- 取消培训
        el-dialog(title="请填写取消原因" :visible.sync="dialogFormVisible"  width='50%' :modal-append-to-body='false'  :close-on-click-modal='false' @close="cancelClose")
          el-form( ref="form" style='margin:0 auto;')
            el-form-item()
                el-input(type="textarea" :rows="5" resize="none" )
            el-row(style='margin-top:30px;')
              el-col(align='center')
                el-button(type="primary" ) 确认
                el-button(@click="dialogFormVisible=false" style='margin-left:50px;') 取消
</template>

<script>
// import AddOrUpdate from "./add-or-update";
import AddOrUpdate from "../addOrUpdate";
// import QueryView from "./query-view";
import QueryView from "../queryView";
import ElEnrollInfo from "./el-enroll-info";
import commonData from "../../common.js"
export default {
  name: "train-group",
  data() {
    return {
      // pxLevel: commonData.pxLevel,
      pxState: commonData.pxState,
      dataForm: {
        pxName:'',
        orgId:'',
        trainLeve:'',
        state:'', //状态(1:未审核，2:已拒绝，3:已发布，4:报名中，5:报名结束，6:已开赛，7:已结束，8:已取消)
        pxTime:'',
      },

      dialogFormVisible: false,
      isCollapse: true,
      loading: null,
      gradeInfoVisible: false,
      gradeInfoDoubleVisible: false,
      updateRefereeVisible: false,
      addOrUpdateVisible: false,
      queryViewVisible: false,
      elEnrollInfoVisible: false,
      selChangeData: [],
      tableData: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
     // restaurants: [],
      matchId: "",
      
      levelOptions: [],
      sysOrgList: [],
      levelDisabled: true,
    };
  },
  components: {
    AddOrUpdate,
    QueryView,
    ElEnrollInfo,
  },
  mounted() {
    this.getDataList();
    this.initCity();
    console.log(new Date('2019-11-11'.replace(/-/,"/")).getTime()>new Date().getTime())
    console.log(new Date().getTime())
  },
  methods: {
    //操作三点
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    cancelClose(){
      this.dialogFormVisible = false
      this.cancelReson = ''
    },
    //报名管理
    enrollClick(row,projectType) {
      this.elEnrollInfoVisible = true;
      this.$nextTick(() => {
        this.$refs.elEnrollInfo.init(row);
      });
      
    },
    //结束
    overBm(id) {
       this.$confirm('确定结束培训？','提示',{
        confirmButtonText:'确定',
        cancelButtonText:'取消',
        type:'warning'
      }).then(()=>{
        this.$http({
          url: this.$http.adornUrl('/pxTrain/overTrain/'+id),
          method: 'post',
        }).then(e => {
          if (e.code === 0) {
            this.$message.success('操作成功！')
            this.getDataList();
          }
        })
      }).catch(()=>{
        this.$message.info('已取消！')
      })

    },
    openFullScreen() {
      this.loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
    },
    //type 1:查看 2:审核发布 
    queryHandle(id, type) {
      this.queryViewVisible = true;
      this.$nextTick(() => {
        this.$refs.queryView.init(id, type,5);
      });
    },
    queryList(){
      this.pageIndex = 1
      this.getDataList()
    },
    //添加或修改事件 flagType:1:新增 2:修改 3:复制并新建
    addOrUpdateHandle(id,flagType) {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        //新增培训类型(1:单次 2：整期 3：青少年 4：个人定制化 5：团体定制化
        this.$refs.addOrUpdate.init(id,flagType,5);
      });
    },

    getDataList() {
      this.dataListLoading = true;
      let applyStrTime = '';
      let applyEndTime = '';
      if (this.dataForm.pxTime) {
        if (this.dataForm.pxTime.length > 0) {
          applyStrTime = this.dataForm.pxTime[0];
          applyEndTime = this.dataForm.pxTime[1];
        }
      }
      this.$http({
        url: this.$http.adornUrl("/pxTrain/list"),
        method: "post",
        // params: this.$http.adornParams
        data:{
          name: this.dataForm.pxName,
          orgId: this.dataForm.orgId,
          // trainLeve: this.dataForm.trainLeve,
          // applyStrTime: applyStrTime,
          // applyEndTime: applyEndTime,
          state: this.dataForm.state,
          type:5,
          page: this.pageIndex,
          limit: this.pageSize

        }
      }).then(data => {
        if (data && data.code === 0) {
          this.tableData = data.page.records;
          this.totalPage = data.page.total;
        } else {
          this.tableData = [];
          this.totalPage = 0;
        }
        this.dataListLoading = false;
      });
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },
    changeItem(value) {
      this.dataForm.level = "";
      if (value.length > 0) {
        this.levelDisabled = false;
        this.placeholderLevel = "请选择";
        if (value == "1") {
          this.levelOptions = this.levelOptionsOne;
        }
        if (value == "2") {
          this.levelOptions = this.levelOptionsTwo;
        }
      } else {
        this.levelDisabled = true;
        this.placeholderLevel = "必须先选择比赛项目";
        this.levelOptions = [];
      }
    },
    initCity() {
      this.$http({
        url: this.$http.adornUrl("/sysOrg/list"),
        method: "get"
      }).then(data => {
        this.sysOrgList = data && data.code === 0 ? data.list : [];
      });
    },
    //勾选列表事件
    selectionChangeHandle(val) {
      this.selChangeData = val;
    }
  }
};
</script>
<style >
/* 操作三点 菜单样式 */
 @import '../../../css/opr3dot.css';

.inputWidth {
  width: 200px;
}
.el-form--inline .el-form-item {
  display: inline-block;
  margin-right: 0px;
  vertical-align: top;
}

/* 提示框 */
.el-tooltip__popper.is-light{
  border: 1px solid #C0C4CC;
}

.el-tooltip__popper[x-placement^=bottom] .popper__arrow{
  border-bottom-color: grey  !important ;
}

.toolTip>p{
  margin: 0;
  padding-top: 10px;
  height:14px;
  line-height:14px;
  font-size:14px;
  color: #606266;
}
</style>

